define('app/sds/attributes/sds-attributes',["$parse", "factory!sdc-bound-expression", "service!sds-service-attributes"], function ($parse, boundExpression, serviceAttributesService) {
	"use strict";
	return {
		restrict: "A",
		transclude: true,
		controller: {
			bind: {
				"expr": "@sdsAttributes"
			},
			constructor: ["$self", "$transclude", "$scope", function (vm, $transclude, $scope) {
				var parts = vm.expr.split(/\sas\s/),
					attrAs = $parse(parts[0]),
					getAttrs = boundExpression(parts[1], $scope.$parent, {
						$attrs: {
							service: serviceAttributesService
						}
					});
				vm.transclude = transclude;
				vm.loading = getAttrs().then(function (attrs) {
					if (vm.targetScope) {
						attrAs.assign(vm.targetScope, attrs);
					}
					vm.attrs = attrs;
				});
				function transclude(link) {
					return $transclude(function (clone, scope) {
						attrAs.assign(scope, vm.attrs);
						vm.targetScope = scope;
						scope.$on("$destroy", function () {
							if (scope === vm.targetScope) {
								delete vm.targetScope;
							}
						});
						return link.apply(this, arguments);
					});
				}
			}]
		}
	};
});
